export const LOG_TABLE_EMPTY = "—"

const trimText = (value) => {
    if (value == null) return ""
    return String(value).trim()
}

/** User assigned to confirm the log (korisnikPotvrda or kirisnikIdPotvrda). */
export const formatLogConfirmerCell = (log, employeesData) => {
    const fromField = trimText(log.korisnikPotvrda)
    if (fromField) return fromField

    const emp = employeesData?.[log.kirisnikIdPotvrda]
    if (emp) return `${emp.ime} ${emp.prezime}`

    return LOG_TABLE_EMPTY
}

/** Admin who last edited the log time (izmenio stores user_id). */
export const formatLogEditorCell = (log, employeesData) => {
    if (!log.izmenio) return LOG_TABLE_EMPTY

    const emp = employeesData?.[log.izmenio]
    if (emp) return `${emp.ime} ${emp.prezime}`

    return LOG_TABLE_EMPTY
}

/** @returns {"confirmed"|"pending"} — checkmark or dash */
export const getLogConfirmationState = (log) =>
    log.potvrdioPotvrda === true ? "confirmed" : "pending"

const CONFIRMATION_ICON = {
    confirmed: {
        label: "Potvrđeno",
        path: "M5 13l4 4L19 7",
        color: "#16a34a"
    },
    pending: {
        label: "Nije potvrđeno",
        path: "M6 12h12",
        color: "#94a3b8"
    }
}

export const LogConfirmationStatusIcon = ({ log }) => {
    const state = getLogConfirmationState(log)
    const cfg = CONFIRMATION_ICON[state]

    return (
        <span
            className={`asv-emp-day-log-confirm-icon asv-emp-day-log-confirm-icon--${state}`}
            title={cfg.label}
            aria-label={cfg.label}
        >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
                <path
                    d={cfg.path}
                    fill="none"
                    stroke={cfg.color}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}

/** Formats the attendance type column (tipPotvrda from API). */
export const formatAttendanceTypeCell = (log) => {
    const type = trimText(log.tipPotvrda)
    return type || LOG_TABLE_EMPTY
}

/** Formats the location column (lokacija_prijave from API). */
export const formatLogLocationCell = (log) => {
    const loc = trimText(log.lokacija_prijave)
    if (!loc) return LOG_TABLE_EMPTY
    if (loc.toLowerCase() === "frontend") return "remote"
    return loc
}
